export * from './panel-clients.descriptor';
export * from './panel-clients-add.descriptor';
export * from './panel-clients-edit-users.descriptor';
export * from './panel-clients-edit-payments.descriptor';
export * from './panel-clients-edit-accounts.descriptor';
export * from './panel-clients-edit-two-factor.descriptor';
export * from './panel-clients-edit-documents.descriptor';
export * from './panel-clients-edit-bank-accounts.descriptor';
export * from './panel-clients-edit-crypto-deposit-addresses.descriptor';

export * from './personal-details-component.descriptor';
export * from './nationalities-component.descriptor';
export * from './identity-details-component.descriptor';
export * from './identification-number-form.descriptor';
export * from './tax-details-component.descriptor';
export * from './addresses-component.descriptor';
export * from './contact-details-component.descriptor';
export * from './purpose-of-trading-component.descriptor';
export * from './source-of-funds-component.descriptor';
export * from './source-of-incomes-component.descriptor';
export * from './estimated-worth-component.descriptor';
export * from './localized-details-component.descriptor';
export * from './audit-trail-component.descriptor';
export * from './document-details-component.descriptor';
export * from './verification-statuses-component.descriptor';
export * from './user-details-component.descriptor';
export * from './upload-documents-component.descriptor';
export * from './pep-details-component.descriptor';
export * from './jurisdictional-risk-component.descriptor';
export * from './compliance-risk-component.descriptor';
export * from './trade-settings-component.descriptor';

export * from './add-document-component.descriptor';
export * from './add-bank-account-component.descriptor';
export * from './disable-accounts-component.descriptor';
export * from './add-user-to-client-component.descriptor';
export * from './change-client-status-component.descriptor';
export * from './reset-password-result-component.descriptor';

export * from './panel-clients-edit-market-data.descriptor';

export * from './company';
